import { render, staticRenderFns } from "./showTrip.vue?vue&type=template&id=2c08b342"
import script from "./showTrip.vue?vue&type=script&lang=js"
export * from "./showTrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports